import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/app/config/global.scss");
